module.exports = __webpack_public_path__ + "static/img/bg2.c9d639d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/year2023/bg2.png
// module id = /uwJ
// module chunks = 0